import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { CircleStackIcon, CpuChipIcon, CreditCardIcon, DocumentTextIcon, KeyIcon, UsersIcon, WalletIcon, WrenchScrewdriverIcon, } from '@heroicons/react/24/outline';
const configLinks = [
    {
        to: '/admin/users',
        title: 'Kullanıcılar ve roller',
        description: 'Hesap rolleri, erişim ve üyelik yönetimi',
        icon: _jsx(UsersIcon, {}),
    },
    {
        to: '/admin/storage-providers',
        title: 'Depolama sağlayıcıları',
        description: 'S3, MinIO, GCS, Azure ve özel endpointler',
        icon: _jsx(CircleStackIcon, {}),
    },
    {
        to: '/admin/social-providers',
        title: 'Social Login',
        description: 'Google, GitHub, Microsoft ve diğer OAuth kaynakları',
        icon: _jsx(KeyIcon, {}),
    },
    {
        to: '/admin/ai-providers',
        title: 'AI sağlayıcılar',
        description: 'Model API anahtarları, endpoint ve limitler',
        icon: _jsx(CpuChipIcon, {}),
    },
    {
        to: '/admin/ai-prompts',
        title: 'AI promptlar',
        description: 'Sistem promptları ve model eşlemeleri',
        icon: _jsx(DocumentTextIcon, {}),
    },
    {
        to: '/admin/payment-providers',
        title: 'Ödeme sağlayıcıları',
        description: 'Stripe, iyzico ve abonelik planları',
        icon: _jsx(CreditCardIcon, {}),
    },
    {
        to: '/admin/crypto-wallets',
        title: 'Kripto cüzdanları',
        description: 'USDT, USDC ve ağ adresleri',
        icon: _jsx(WalletIcon, {}),
    },
    {
        to: '/admin/disclaimers',
        title: 'Disclaimers',
        description: 'Terms, privacy, cookie ve uyarı metinleri',
        icon: _jsx(DocumentTextIcon, {}),
    },
    {
        to: '/admin/install',
        title: 'Kurulum',
        description: 'Veritabanı migrasyonları, seed ve sistem kurulumu',
        icon: _jsx(WrenchScrewdriverIcon, {}),
    },
];
export function Settings() {
    return (_jsxs("div", { className: "admin-page", children: [_jsx("header", { className: "admin-page-header", children: _jsxs("div", { children: [_jsx("h1", { children: "Ayarlar" }), _jsx("p", { children: "Global uygulama ayarlar\u0131 i\u00E7in ayr\u0131 bir API yok. Yap\u0131land\u0131rma ilgili admin ekranlar\u0131ndan y\u00F6netilir." })] }) }), _jsx("div", { className: "admin-settings-hub", children: configLinks.map((item) => (_jsxs(Link, { to: item.to, className: "admin-settings-hub-card", children: [_jsx("span", { className: "admin-settings-hub-icon", "aria-hidden": true, children: item.icon }), _jsxs("span", { className: "admin-settings-hub-text", children: [_jsx("span", { className: "admin-settings-hub-title", children: item.title }), _jsx("span", { className: "admin-settings-hub-desc", children: item.description })] })] }, item.to))) })] }));
}
